const colors = [
  "#ff5398",
  "#ffb14a",
  "#7afcff",
  "#ff7eb9",
  "#fff200",
  "#00D084"
];

export default colors;
